const header = document.querySelector('.page-section--header');
const logoElement = header.querySelector(".logo__image");
const logoSrc = logoElement.getAttribute('src');
const logoForWhiteBg = 'dochub.svg';

function handleScroll() {
  if (window.scrollY >= 5) {
    header.classList.add('sticky-header');
    logoElement.setAttribute('src', logoSrc.replace(/[^/]+$/, logoForWhiteBg));
  } else {
    header.classList.remove('sticky-header');
    logoElement.setAttribute('src', logoSrc);
  }
}

window.addEventListener('scroll', handleScroll);

export default handleScroll;